module.exports = __webpack_public_path__ + "static/media/log_view.aa18d459.ico";